// extracted by mini-css-extract-plugin
export default {"input_area":"InputTable_input_area__vOdLE","table":"InputTable_table__PVQEz"};